module.exports = __webpack_public_path__ + "img/erp-logos_0014_sageone.ebd1851d.jpg";